module.exports = __webpack_public_path__ + "static/media/facebook.1f4aaa7c.svg";